/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";

import { ReactNode } from "react";
import { Button, ButtonProps } from "reactstrap";
import useNavigateFrom from "../../utils/useNavigateFrom";

export const formContainerMaxWidth = css`
    max-width: 1200px;
    margin: 0 auto;
`;

interface FormContainerProps {
    title?: ReactNode;
    subtitle?: ReactNode;
    actionsTop?: ReactNode
    actionsBottom?: ReactNode
    fullWidth?: boolean;
    buttonProps?: ButtonProps;
    children: ReactNode;
    styles?: SerializedStyles
    className?: string;
    backTo?: string;
    breadcrumbs?: ReactNode;
}

export const FormContainer = ({ title, subtitle, actionsTop, actionsBottom, fullWidth, children, className, styles, buttonProps, backTo, breadcrumbs }: FormContainerProps) => {
    const { goBack } = useNavigateFrom();

    const actionsClassName = "mt-2 mt-md-4 w-100 d-flex flex-wrap gap-2 justify-content-end";

    const backButtonProps = {
        href: backTo,
        onClick: backTo ? undefined : () => goBack(),
    };

    return (
        <>
            {actionsTop && (
                <div className={`mb-2 mb-md-4 ${actionsClassName}`} css={!fullWidth && formContainerMaxWidth}>
                    {actionsTop}
                </div>
            )}

            <div
                className={`d-flex flex-column bg-white mx-auto py-4 py-md-5 px-3 px-md-4 gap-4 gap-md-5 rounded-2 shadow-sm position-relative ${className}`}
                css={[css`min-height: 600px;`, !fullWidth && formContainerMaxWidth, styles]}
            >
                <div className="d-flex justify-content-between">
                    <div css={css`max-width: calc(100% - 1rem);`}>
                        {!!breadcrumbs && <div className="pb-2 pb-md-4">{breadcrumbs}</div>}
                        {!!title && <h2>{title}</h2>}
                        {!!subtitle && <p className="mb-0 text-muted">{subtitle}</p>}
                    </div>

                    <Button {...buttonProps} className="btn-close my-1 flex-shrink-0 position-absolute" css={css`top: 1rem; right: 1rem;`} size="lg" {...backButtonProps} />
                </div>

                {children}
            </div>

            {actionsBottom && (
                <div className={`mt-2 mt-md-4 ${actionsClassName}`} css={!fullWidth && formContainerMaxWidth}>
                    {actionsBottom}
                </div>
            )}
        </>
    );
};
